import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M16.841 10a6.042 6.042 0 1 1-12.083 0 6.042 6.042 0 0 1 12.083 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8.925 8.333s.208-1.875 1.875-1.875c1.666 0 1.875 1.042 1.875 1.875 0 .626-.353 1.253-1.059 1.525-.429.166-.816.515-.816.975v.209" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M11.216 13.333a.417.417 0 1 1-.833 0 .417.417 0 0 1 .834 0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);